import { setConfiguration } from 'react-grid-system';

export default (): void => {
  setConfiguration({
    containerWidths: [540, 750, 960, 1170],
  });
};
